// extracted by mini-css-extract-plugin
module.exports = {"root":"Rectangle_root__72L3_","center":"Rectangle_center__7TbGP","content":"Rectangle_content__2UKVS"};